import React from 'react'

import { Link } from "react-router-dom";
export default function Body(props) {

  return (
    <div>
   
      <div className="  card my-3"  style= {{width: "19rem"}}>
      <img src={props.img}  className="card-img-top" alt="..."/>

        <div className="card-body">
            <h4 className="card-title">{props.dept} </h4>
            <h6 className="card-text">Triguna Sen School of Technology, Assam University Silchar</h6>
            <Link to={props.ink} className="btn btn-primary">{props.title}</Link>
        </div>
      </div>
      {/* <Outlet/> */}
    </div>
  );
}
